exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-9a228702] {\n  background: #f1f2f5;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  min-height: calc(100vh - 96px);\n}\n.box[data-v-9a228702] {\n  max-height: 600px;\n  background: #fff;\n  padding: 15px 20px;\n  border-radius: 8px;\n}", ""]);

// exports
